import React from "react";

const SimpleCol = ({ children }) => (
  <div className="simple-col">{children}</div>
);

export default SimpleCol;
